<template>
  <div class="box">
    <label class="checkbox has-text-weight-bold has-margin-bottom">
      <input
        type="checkbox"
        @change="updateYieldPlayground"
        v-model="yieldSettingsPlayground.ApplySpaceUtilization"
      />
      Space utilization
    </label>
    <span class="has-margin-left">
      <a @click="setShowInfo">
        <span class="icon is-small">
          <font-awesome-icon :icon="['fas', 'info-circle']" />
        </span>
      </a>
    </span>

    <div v-if="showInfo">
      <article class="message is-info is-small">
        <div class="message-body">
          When activated will apply a discount or a surcharge based on the
          utilization of the space
        </div>
      </article>
    </div>

    <div
      v-if="
        yieldSettingsPlayground.ApplySpaceUtilization && mShowBox && !showInfo
      "
    >
      <table class="table is-fullwidth">
        <tbody>
          <tr>
            <td width="6" class="is-size-7">0%</td>
            <td>
              <vue-slider
                v-model="spaceUtilizationValues"
                direction="rtl"
                :min="0"
                :max="200"
                :minRange="1"
                :interval="1"
                :tooltip-formatter="formatter"
                @change="updateYieldSettingsSpaceUtilizationValues"
                @drag-end="updateYieldPlayground"
              ></vue-slider>
            </td>
            <td width="6" class="is-size-7">100%</td>
          </tr>
        </tbody>
      </table>

      <article class="message is-info is-small">
        <div class="message-body">
          <div>
            0% occupancy apply
            {{
              roundToZero(
                yieldSettingsPlayground.SpaceUtilizationBottomValue * 100 - 100
              )
            }}% surcharge
          </div>
          <div>
            100% occupancy apply
            {{
              roundToZero(
                yieldSettingsPlayground.SpaceUtilizationTopValue * 100 - 100
              )
            }}% discount
          </div>
        </div>
      </article>
    </div>

    <div
      v-if="yieldSettingsPlayground.ApplySpaceUtilization"
      class="has-text-centered has-margin-top"
    >
      <a @click="mShowBox = !mShowBox" class="button is-small is-rounded">
        <span v-if="mShowBox" class="icon is-small">
          <font-awesome-icon :icon="['fas', 'chevron-up']" />
        </span>
        <span v-if="!mShowBox" class="icon is-small">
          <font-awesome-icon :icon="['fas', 'chevron-down']" />
        </span>
      </a>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapState } from 'vuex'
import VueSlider from 'vue-slider-component'
import 'vue-slider-component/theme/default.css'

export default {
  components: {
    VueSlider
  },

  props: {
    showBox: {
      type: Boolean,
      default: true
    }
  },

  data() {
    return {
      formatter: v => `${v - 100}%`,
      mShowBox: true,
      showInfo: false
    }
  },

  computed: {
    ...mapState('yieldStore', ['yieldSettingsPlayground'])
  },

  watch: {
    showBox: {
      immediate: true,
      handler: function(newVal, oldVal) {
        this.mShowBox = newVal
      }
    }
  },

  created() {
    this.spaceUtilizationValues = this.getSpaceUtilizationValues()
  },

  methods: {
    ...mapMutations('yieldStore', ['setYieldSettingsPlayground']),

    setShowInfo() {
      this.showInfo = !this.showInfo
      if (this.showInfo) {
        this.mShowBox = true
      }
    },

    getSpaceUtilizationValues() {
      return [
        this.roundToZero(
          this.yieldSettingsPlayground.SpaceUtilizationBottomValue * 100
        ),
        this.roundToZero(
          this.yieldSettingsPlayground.SpaceUtilizationTopValue * 100
        )
      ]
    },

    updateYieldPlayground() {
      this.setYieldSettingsPlayground(this.yieldSettingsPlayground)
      this.$emit('yieldSettingsUpdated')
    },

    updateYieldSettingsSpaceUtilizationValues() {
      let self = this

      let bottomValue = self.spaceUtilizationValues[1] / 100
      let topValue = self.spaceUtilizationValues[0] / 100

      self.yieldSettingsPlayground.SpaceUtilizationBottomValue = bottomValue
      self.yieldSettingsPlayground.SpaceUtilizationTopValue = topValue
    },

    roundToZero(num) {
      let self = this
      return +(Math.round(self.roundToTwo(num) + 'e+0') + 'e-0')
    },

    roundToTwo(num) {
      return +(Math.round(num + 'e+2') + 'e-2')
    }
  }
}
</script>
